export default __webpack_public_path__ + "static/media/ARMDQO_1.23ba41e5.jpg";